export const VISIBLE_AUTOCOMPLETE_TEST_IDS = {
  root: 'visible-autocomplete',
  input: 'visible-autocomplete-input',
  listbox: 'visible-autocomplete-listbox',
  option: (value: string) => `visible-autocomplete-option-${value}`
} as const

export const VISIBLE_AUTOCOMPLETE_DEFAULT_MAX_HEIGHT = 360
